import { useEffect, useMemo, useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Dashboard from "./Dashboard/Dashboard";
import PolicyDetails from "./PolicyDetails/PolicyDetails";
import PaymentSuccess from "./Payment/PaymentSuccess";
import PaymentCancel from "./Payment/PaymentCancel";
import Tasks from "./Tasks/Tasks";
import Profile from "./Profile/Profile";
import { Box } from "@mui/material";
import InsureAssist from "./Dashboard/InsureAssist/InsureAssist";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import { getCookie, isFeatureAvailable } from "../utils/Utility";
import { useAppSelector } from "../store/hooks";
import { RootState } from "../store/store";
import Error from "../common/Error/Error";
import { IFeature } from "../models/admin/features/features";
import { Typed } from "react-typed";
import PoliciesList from "./Dashboard/Policies/PoliciesList/PoliciesList";
import ClaimsList from "./Dashboard/Claims/ClaimsList/ClaimsList";
import NewCustomerDashboard from "./newCustomerDashboard/NewCustomerDashboard";
import VoiceForms from "./voiceForms/VoiceForms";
 
const CustomerRoutes = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const authenticated = getCookie("authenticated");
  const roleCode = getCookie("roleCode");
 
  const { features } = useAppSelector((state: RootState) => state.features);
 
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [typed, setTyped] = useState<Typed | undefined>();
  const [chatWidth, setChatWidth] = useState<number | null>(null);
 
  const showInsureAssist: boolean = useMemo(
    () =>
      features.some(
        (feature: IFeature) =>
          feature.featureCode === "insure_assist" && feature.selected
      ),
    [features]
  );
 
  useEffect(() => {
    if (!authenticated || roleCode !== "2") {
      navigate("/login");
    }
  }, [authenticated, roleCode, navigate]);
 
  useEffect(() => {
    const page = location.pathname.split("/")[2];
    if (page === "newcustomerDashboard" || page === "voiceForms") {
      setIsOpen(false);
    }
  }, [setIsOpen, location.pathname]);
  return authenticated && roleCode === "2" ? (
    <Box
      sx={{
        background: "linear-gradient(180deg, #fbfdfc 0%, #e5f6fe 100%)",
        position: "relative",
        height: isOpen ? "100vh":"",
        // Keep horizontal overflow visible; we don't need x-scroll
        overflowX: "visible",
        // Show vertical scroll and move its gutter in front of chat
        overflowY: isOpen ? "auto" : "visible",
        // Use right margin to shift scrollbar left of the fixed chat panel
        mr: isOpen && chatWidth ? `${chatWidth}px` : 0,
      }}
    >
      <Box
        sx={{
          // Keep content width normal; no x-scroll hack needed
          //minWidth: "100%",
          minWidth: isOpen && chatWidth ? `calc(100% + ${chatWidth}px)` : "100%",
        }}
      >
        <Header
          isInsureAssistOpen={isOpen}
          setIsInsureAssistOpen={setIsOpen}
          showInsureAssist={showInsureAssist}
          chatWidth={chatWidth}
        />
        <Routes>
          <Route
            index
            element={
              <Dashboard
                setIsOpen={setIsOpen}
                isDisabled={isDisabled}
                setIsDisabled={setIsDisabled}
                typed={typed}
                setTyped={setTyped}
              />
            }
          />
          <Route
            path="/dashboard"
            element={
              <Dashboard
                setIsOpen={setIsOpen}
                isDisabled={isDisabled}
                setIsDisabled={setIsDisabled}
                typed={typed}
                setTyped={setTyped}
              />
            }
          />
          <Route path="/policies" element={<PoliciesList />} />
 
          <Route path="/claims" element={<ClaimsList />} />
          <Route
            path="/newcustomerDashboard"
            element={<NewCustomerDashboard />}
          />
          <Route path="/voiceForms" element={<VoiceForms />} />

          <Route
            path="/policyDetails/:policyId/:carrier/:system/:lobCode"
            element={<PolicyDetails />}
          />
          <Route
            path="/paymentSuccess/:responseData"
            element={<PaymentSuccess />}
          />
          <Route
            path="/service-requests"
            element={
              isFeatureAvailable({ featureCodes: ["my_tasks"], features }) ? (
                <Tasks />
              ) : (
                <Error />
              )
            }
          />
          <Route path="/paymentError/:errorCode" element={<PaymentCancel />} />
          <Route
            path="/profile"
            element={
              isFeatureAvailable({ featureCodes: ["profile"], features }) ? (
                <Profile />
              ) : (
                <Error />
              )
            }
          />
          <Route
            path="*"
            element={
              <Dashboard
                setIsOpen={setIsOpen}
                isDisabled={isDisabled}
                setIsDisabled={setIsDisabled}
                typed={typed}
                setTyped={setTyped}
              />
            }
          />
        </Routes>
        {location.pathname.split("/")[2] !== "newcustomerDashboard" &&
          location.pathname.split("/")[2] !== "voiceForms" && <Footer />}
      </Box>
      {isFeatureAvailable({ features, featureCodes: ["insure_assist"] }) ? (
        <InsureAssist
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          setIsDisabled={setIsDisabled}
          typed={typed}
          setChatWidth={setChatWidth}
        />
      ) : (
        <></>
      )}
    </Box>
  ) : (
    <></>
  );
};
 
export default CustomerRoutes;
